export default __webpack_public_path__ + "static/media/3059.95fa077a.jpg";